import { FC } from 'react';
import { ATTIO_CURRENT_VALUATIONS_FILTER } from 'dashboard409a/common/constants/analyst-dashboard';
import WorkboardDataTable from '../WorkboardDataTable';

const WorkboardCurrentJobs: FC = () => (
  <WorkboardDataTable
    filters={ATTIO_CURRENT_VALUATIONS_FILTER}
  />
);

export default WorkboardCurrentJobs;
